// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"j-z","heading":"k-z","screenReadersOnly":"l-z"};